import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor() {
  }

  public noAllWhitespaceValidator(control: FormControl) {
    if (control.value.length > 0 && control.value.trim().length === 0){
      return { 'whitespace': true }
    }
    return null
  }
}
